/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IntranetUsersControllerGetIntranetUsers200Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    /**
     * JSON encriptado de un arreglo con: uuid, firstName, middleName, lastName, fullName, email, phone, enrollment, photoProfileUrl, jobPositionId, jobPositionName, departmentId, departmentName, companyId, companyName
     */
    data?: string;
    error?: string;
}

